import { useFilterEmployeeLedgerContext } from "./filter-employee-ledger.context";

export function FilterEmployeeLedger() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterEmployeeLedgerContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}